import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'

const useCalendarRange = dataBegin => {
  const createdDate = useSelector(state => state.account.current.createdDate)
  let min = null
  if (dataBegin && createdDate) {
    min = moment
      .max(moment(createdDate, 'YYYY-MM-DD[T]HH:mm:ss'), dataBegin)
      .format(moment.HTML5_FMT.DATE)
  } else if (dataBegin) {
    min = dataBegin.format(moment.HTML5_FMT.DATE)
  } else if (createdDate) {
    min = moment(createdDate, 'YYYY-MM-DD[T]HH:mm:ss').format(
      moment.HTML5_FMT.DATE
    )
  }
  return {
    min,
    max: moment().format(moment.HTML5_FMT.DATE),
  }
}
useCalendarRange.propTypes = {
  dataBegin: PropTypes.instanceOf(moment),
}
export default useCalendarRange
